'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dU$002dU$002dI$002dD from "./java.util.-U-U-I-D.js";
var $p;
function $ps_ju_UUID$__fail$1__T__E(name$1) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), ("Invalid UUID string: " + name$1));
}
export { $ps_ju_UUID$__fail$1__T__E as $ps_ju_UUID$__fail$1__T__E };
/** @constructor */
function $c_ju_UUID$() {
}
export { $c_ju_UUID$ as $c_ju_UUID$ };
$p = $c_ju_UUID$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_UUID$;
/** @constructor */
function $h_ju_UUID$() {
}
export { $h_ju_UUID$ as $h_ju_UUID$ };
$h_ju_UUID$.prototype = $p;
$p.P6 = (function(name) {
  if ((((((name.length !== 36) || (name.charCodeAt(8) !== 45)) || (name.charCodeAt(13) !== 45)) || (name.charCodeAt(18) !== 45)) || (name.charCodeAt(23) !== 45))) {
    $ps_ju_UUID$__fail$1__T__E(name);
  }
  try {
    var his = name.substring(0, 4);
    var los = name.substring(4, 8);
    var i1 = (($j_java$002elang$002e$002dObject.$m_jl_Integer$().ez(his, 16, 134217728) << 16) | $j_java$002elang$002e$002dObject.$m_jl_Integer$().ez(los, 16, 134217728));
    var his$1 = name.substring(9, 13);
    var los$1 = name.substring(14, 18);
    var i2 = (($j_java$002elang$002e$002dObject.$m_jl_Integer$().ez(his$1, 16, 134217728) << 16) | $j_java$002elang$002e$002dObject.$m_jl_Integer$().ez(los$1, 16, 134217728));
    var his$2 = name.substring(19, 23);
    var los$2 = name.substring(24, 28);
    var i3 = (($j_java$002elang$002e$002dObject.$m_jl_Integer$().ez(his$2, 16, 134217728) << 16) | $j_java$002elang$002e$002dObject.$m_jl_Integer$().ez(los$2, 16, 134217728));
    var his$3 = name.substring(28, 32);
    var los$3 = name.substring(32, 36);
    var i4 = (($j_java$002elang$002e$002dObject.$m_jl_Integer$().ez(his$3, 16, 134217728) << 16) | $j_java$002elang$002e$002dObject.$m_jl_Integer$().ez(los$3, 16, 134217728));
    return new $j_java$002eutil$002e$002dU$002dU$002dI$002dD.$c_ju_UUID(i2, i1, i4, i3);
  } catch (e) {
    if ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_NumberFormatException)) {
      $ps_ju_UUID$__fail$1__T__E(name);
    } else {
      throw e;
    }
  }
});
var $d_ju_UUID$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_UUID$, "java.util.UUID$", ({
  nk: 1,
  a: 1
}));
export { $d_ju_UUID$ as $d_ju_UUID$ };
var $n_ju_UUID$;
function $m_ju_UUID$() {
  if ((!$n_ju_UUID$)) {
    $n_ju_UUID$ = new $c_ju_UUID$();
  }
  return $n_ju_UUID$;
}
export { $m_ju_UUID$ as $m_ju_UUID$ };
